import React from 'react';
import {HealthParameterType} from '../../common/config';
import HealthComponent from '../health-component/health-component';

export default function RespirationRate() {
  return <HealthComponent type={HealthParameterType.RESPIRATION_RATE} />;
}
